<template>
  <div>
    <v-btn text dark class="mb-4">
      <v-avatar
        rounded
        color="#3e3e3d"
        class="pa-2 cursor-pointer"
        @click="openMenu"
      >
        <v-icon dark>
          mdi-apps
        </v-icon>
      </v-avatar>
    </v-btn>
    <v-snackbar
      :color="snackbarColor"
      v-model="snackbar"
      timeout="5000"
      top
      right
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="600px" scrollable>
      <v-card>
        <v-card-title style="color:#9ac31c;font-size:x-large"
          >Instalación Apps</v-card-title
        >
        <v-divider></v-divider>
        <v-card-subtitle style="font-size:large;"
          ><strong>{{ apps.length }} Apps disponibles</strong></v-card-subtitle
        >
        <v-card-text style="height: 300px">
          <bx-table :data="apps" :columns="columns">
            <template slot-scope="props">
              <bx-table-column centered class="pt-5">
                {{ props.row.name }}
              </bx-table-column>
              <bx-table-column centered class="pt-5">
                <v-select
                  :items="props.row.versions"
                  item-text="name"
                  item-value="id"
                  outlined
                  @change="selectedVersion($event, props.row.id)"
                ></v-select>
              </bx-table-column>
              <bx-table-column>
                <v-checkbox
                  color="#9ac31c"
                  class="checkbox"
                  v-model="app"
                  v-bind:value="props.row"
                ></v-checkbox>
              </bx-table-column>
            </template>
          </bx-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-center align-items-center">
          <v-btn
            color="#717C7D"
            text
            @click="dialog = false"
            rounded
            class="mr-5"
            >Close</v-btn
          >
          <bx-btn
            color="primary"
            text
            @click="download"
            rounded
            class="ml-5 text-uppercase"
            >Download</bx-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apps: [],
      dialog: false,
      app: [],
      columns: [],
      selectVersion: [],
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#9ac31c"
    };
  },
  props: ["selectedRows"],
  methods: {
    async openMenu() {
      if (this.selectedRows.length > 0) {
        let apps = await this.$api.nms.list_apps();
        this.apps = apps;
        this.app = [];
        this.selectVersion = [];
        this.columns = [
          {
            field: "name"
          },
          {
            field: "versions"
          },
          {
            field: "selection"
          }
        ];
        this.dialog = true;
      } else {
        this.snackbarText = this.$t(`lang.admin.select_device`);
        this.snackbarColor = "red darken-2";
        this.snackbar = true;
        this.dialog = false;
      }
    },
    async download() {
      let checkedVersion = this.app.map(version =>
        version.versions.find(versionid =>
          this.selectVersion.includes(versionid.id)
        )
      );
      let version = checkedVersion.map(version => version.id);
      if (version.length) {
        this.$emit("download_apps", version);
      }
      this.dialog = false;
    },
    selectedVersion(value, id) {
      this.selectVersion.push(value);
    }
  }
};
</script>

<style></style>
